import { getAndroidQrcode } from "@axios/api.device";
import { Breadcrumb, Button, Image, Row, Space, Spin, Timeline } from "antd";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

const envObj = process.env;
export const EnrollmentAndroid = () => {
  const [qrcode, setQrcode] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation();
  
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    getAndroidQrcode("Android", 5).then((res) => {
      setQrcode(res);
      setLoading(false);
    });
  };
  
  return (
    <div className="fullBox">
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("安卓")}</Breadcrumb.Item>
        </Breadcrumb>
        <Row style={{padding: "32px 0 11px 0"}}>
            <Space>
                <img src="/images/androidIcon.svg" alt="" />
                <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("安卓")}</span>
            </Space>
        </Row>
        <Row>
          <p style={{ margin: "14px 0px 0px 0px", display: "flex", alignItems: "center" }}>
            <img src="/images/tipIcon.svg" alt="" />
            <span style={{ marginLeft: 4, fontSize: 12, fontWeight: 500, color: "#666666" }}>
              {t("提示")}: {t("安卓设备可以通过连接电脑,获取Device Owner权限的方式达到更多管控的功能")}&nbsp;&nbsp;
              <a href="https://willing-mdmdev.oss-cn-hangzhou.aliyuncs.com/mdm/%E5%AE%89%E5%8D%93%E8%AE%BE%E5%A4%87%E8%8E%B7%E5%8F%96device%20owner%E6%9D%83%E9%99%90.pdf" target="_blank">{t("点击查看步骤")}</a>
            </span>
          </p>
        </Row>
      </div>

      <Spin spinning={false}>
        <Row style={{ width: "100%" }}>


          <div className="borderBox" style={{paddingLeft:"40px", paddingBottom:"80px"}}>
                <h5 className="enrollmentNewTitle">{t("第一步")}</h5>
                <div>
                  {t("下载未瓴MDM应用,打开浏览器扫描下方二维码下载或者")}
                  <Button type="link" target="_blank" href="https://static.willingtek.com/MDM-Android/app-universal-release.apk">{t("点击下载")}</Button>
                </div>
                <div className="mt-3">
                  <Image src={envObj.REACT_APP_API_URL?.includes("mdmapi.willingtek.com")?"/images/qrcodePro.png":"/images/qrcode.png"} alt="" width={150} />
                  <div className="ft-12 text-muted">
                  </div>
                </div>
                <h5 className="enrollmentNewTitle">{t("第二步")}</h5>
                <div>
                  {t("手机打开未瓴MDM应用,输入MDM组织ID或者扫描右侧二维码进行下一步操作")}
                  <div className="mt-4">
                    <div style={{ width: "145px", height: "145px" }}>
                      <Spin spinning={loading}>
                        {qrcode && (
                          <Image src={`data:image/jpg;base64,${qrcode}`} alt="" width={150} />
                        )}
                      </Spin>
                    </div>

                    <div className="ft-12 text-muted">
                      {/* {t("打开未瓴MDM应用程序扫码绑定服务器地址")} */}
                    </div>
                  </div>
                </div>
                <h5 className="enrollmentNewTitle">{t("第三步")}</h5>
                <div>{t("点击下一步,激活所有授权请求")}</div>
          </div>
        </Row>
      </Spin>
    </div>
  );
};
